
import { Component, ChangeDetectionStrategy, input, output, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { DataService } from '../../services/data.service';
// FIX: Corrected import path for models.
import { AppUser } from '../../models/index';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'app-invite-employee-modal',
  standalone: true,
  templateUrl: './invite-employee-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule],
})
export class InviteEmployeeModalComponent {
  private dataService = inject(DataService);
  // FIX: Explicitly typed the injected `FormBuilder` to resolve "Property 'group' does not exist on type 'unknown'".
  private fb: FormBuilder = inject(FormBuilder);

  isOpen = input.required<boolean>();
  closeModal = output<void>();

  inviteForm: FormGroup;
  isSubmitting = signal(false);
  errorMessage = signal<string | null>(null);
  inviteLink = signal<string | null>(null);
  copyButtonText = signal('คัดลอกลิงก์ (Copy Link)');
  
  userRoles: AppUser['role'][] = ['staff', 'cashier', 'doctor', 'accountant', 'admin'];

  constructor() {
    this.inviteForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      role: ['staff' as AppUser['role'], Validators.required],
    });
  }

  onClose(): void {
    this.inviteForm.reset({ role: 'staff' });
    this.errorMessage.set(null);
    this.inviteLink.set(null);
    this.copyButtonText.set('คัดลอกลิงก์ (Copy Link)');
    this.closeModal.emit();
  }

  async sendInvite(): Promise<void> {
    if (this.inviteForm.invalid) return;

    this.isSubmitting.set(true);
    this.errorMessage.set(null);
    this.inviteLink.set(null);

    try {
      const { email, role } = this.inviteForm.value;
      const token = await this.dataService.createInvitation(email, role);
      
      // FIX: Standardized URL Construction
      // We explicitly construct the origin and path to handle Hash Routing correctly
      const origin = window.location.origin;
      const path = window.location.pathname; // Should be just '/' in most cases
      
      // Ensure no double slashes and proper hash placement
      // Format: https://domain.com/#/register?token=XYZ
      const cleanPath = path.endsWith('/') ? path : path + '/';
      const fullUrl = `${origin}${cleanPath}#/register?token=${token}`;
      
      this.inviteLink.set(fullUrl);
      this.inviteForm.reset({ role: 'staff' });
    } catch (e) {
      this.errorMessage.set(e instanceof Error ? e.message : 'An unknown error occurred.');
    } finally {
      this.isSubmitting.set(false);
    }
  }

  copyToClipboard(): void {
    if (!this.inviteLink()) return;
    navigator.clipboard.writeText(this.inviteLink()!).then(() => {
      this.copyButtonText.set('คัดลอกเรียบร้อย! (Copied)');
      setTimeout(() => this.copyButtonText.set('คัดลอกลิงก์ (Copy Link)'), 2000);
    });
  }

  onBackdropClick(event: MouseEvent): void {
      if (event.target === event.currentTarget) {
          this.onClose();
      }
  }
}
